const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/supplierEvaluation/detail.do`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBH,
                    '项目类型': getProjectTypeName(res.data.zbxmlx),
                    '采购方式': getPurchaseTypeName(res.data.cgFangShi),
                    '采购单位': res.data.zbrName,
                    '企业代码': res.data.zbrBH,
                    '项目经理': res.data.projectManagerName,
                    '联系电话': res.data.lianXiRenPhone,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
